export class HttpError extends Error {
  httpStatusCode: number;

  /**
   *
   */
  constructor(name: string, message: string, httpStatusCode: number) {
    super(message)
    this.name = name;
    this.httpStatusCode = httpStatusCode;
    Object.setPrototypeOf(this, HttpError.prototype);

  }
}